<template>
  <vs-popup id="popupRiskInfo" :title="$t('중대성(강도)')" :active.sync="popupActiveSync">
    <div class="p-4">
      <div class="risk-info-header">
        <span>{{ $t('중대성(강도)') }}</span>
      </div>
      <div>
        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">{{ $t('최대') }}</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #E42728">{{ $t('사망') }}</span>
          <span style="border-top: none; border-right: none;">4</span>
          <span style="border-top: none; display: block;">
            <p style="text-align: center;">{{ $t('사망 또는 영구적 근로불능으로 연결되는 부상·질병(업무복귀불가능), 장애가 남는 부상·질병') }}</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">{{ $t('대') }}</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #E42728">{{ $t('장해발생') }}</span>
          <span style="border-top: none; border-right: none;">3</span>
          <span style="border-top: none; display: block;">
            <p style="text-align: center;">{{ $t('휴가를 수반하는 중대한 부상 또는 질병 (일정시점에서는 업무에 복귀 가능(완치가능)') }}</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">{{ $t('중') }}</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #FF8510">{{ $t('병원치료') }}</span>
          <span style="border-top: none; border-right: none;">2</span>
          <span style="border-top: none; display: block;">
            <p style="text-align: center;">{{ $t('응급조치 이상의 치료가 필요하지만 휴업이 수반되지 않는 부상 또는 질병') }}</p>
          </span>
        </div>

        <div class="risk-info-body">
          <span style="border-top: none; border-right: none;">{{ $t('소') }}</span>
          <span style="border-top: none; border-right: none; font-weight: bold; color: #28C76F">{{ $t('비치료') }}</span>
          <span style="border-top: none; border-right: none;">{{ $t('최대') }}</span>
          <span style="border-top: none; display: block;">
            <p style="text-align: center;">{{ $t('아차사고로 인한 인적손실이 없는 경우(업무에 전혀 지장이 없음)') }}</p>
          </span>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'PopupRiskInfoEp2',
  props: {
    value: Boolean,
  },
  components: {
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.handleCloseSelf()
      }
    }
  },
  methods: {
    handleCloseSelf () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-info-body {
  display: grid;
  grid-template-columns: 109px 109px 109px 812px;
  span {
    padding: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;

    &.left {
      justify-content: flex-start;
    }
  }
}
.risk-info-header {
  //display: grid;
  //grid-template-columns: 109px 109px 109px 572px 236px;
  //grid-template-areas: "A A A B C" "D E F B C";
  //grid-template-rows: 40px 40px;
  background-color: #F9F9F9;
  span {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    border: 1px solid #DEDEDE;
  }
}
</style>
<style>

#popupRiskInfo > .vs-popup {
  width: 1167px !important;
}

#popupRiskInfo > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupRiskInfo > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}

</style>
